module.exports = __webpack_public_path__ + "static/media/chevron-m-inactive.982cfb80.svg";